import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faDroplet } from '@fortawesome/pro-regular-svg-icons/faDroplet';
import { faPuzzlePiece } from '@fortawesome/pro-regular-svg-icons/faPuzzlePiece';
import { faToilet } from '@fortawesome/pro-regular-svg-icons/faToilet';
import { Option } from '@spike/model';
import { Task } from '@spike/task-model';

// The Tasks tab lists every task type that is NOT feeding (1) or meds (2):
// hydration (3), relief (4) and add-on (5). These map straight to the API task_type.
export type CareSubtype = 'hydration' | 'relief' | 'addon';

interface CareSubtypeMeta {
    taskType: number;
    name: string;
    icon?: IconDefinition;
}

export const CARE_SUBTYPES: Record<CareSubtype, CareSubtypeMeta> = {
    hydration: { taskType: 3, name: 'Hydration', icon: faDroplet },
    relief: { taskType: 4, name: 'Relief', icon: faToilet },
    addon: { taskType: 5, name: 'Add-on', icon: faPuzzlePiece }
};

export const CARE_TASK_TYPES: Array<number> = Object.values(CARE_SUBTYPES).map(meta => meta.taskType);

export const CARE_TYPE_OPTIONS: Array<Option<number>> = Object.values(CARE_SUBTYPES).map(meta => ({
    id: meta.taskType,
    name: meta.name
}));

export interface CareView {
    subtype: CareSubtype;
    taskType: number;
    name: string;
    icon?: IconDefinition;
    instructions?: string;
}

// Normalizes a task's care-family payload (hydration/relief/addon) into one view
// so the renderers don't have to branch on the raw sub-objects.
export const careOf = (task: Task): CareView | undefined => {
    if (task.hydration) {
        return { subtype: 'hydration', ...CARE_SUBTYPES.hydration, instructions: task.hydration.note ?? undefined };
    }
    if (task.relief) {
        return { subtype: 'relief', ...CARE_SUBTYPES.relief, instructions: task.relief.note ?? undefined };
    }
    if (task.addon) {
        return {
            subtype: 'addon',
            ...CARE_SUBTYPES.addon,
            name: task.addon.addonName ?? CARE_SUBTYPES.addon.name
        };
    }
    return undefined;
};
